export class Controls {
  protected controlBarSectionElement: HTMLElement
  protected videoPlayer: HTMLVideoElement
  protected wrapperElement: HTMLDivElement

  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    this.controlBarSectionElement = element
    this.videoPlayer = videoPlayer
    this.wrapperElement = wrapperElement
  }
}
